module.exports = __webpack_public_path__ + "img/mahran.9051908.png";